<template>
  <o-view class="c-home" :no-scroll="true">
    <div class="c-home-top">
      <o-nav-bar title="Mobility Assistent" :has-back-button="true" />
      <o-active-route v-if="activeRoute" />
    </div>
    <o-map
      :fill-space="true"
      :filter-button="false"
      :fullscreen-button="false"
      :markers="markers"
    >
      <template v-slot:buttonsRight>
        <router-link
          v-if="$store.state.showFavoriteButton"
          href="#"
          class="c-map-button c-map-button--favorites"
          :to="{ name: 'favorites' }"
        >
          <o-icon icon="favorite" />
        </router-link>
        <router-link
          href="#"
          class="c-map-button c-map-button--settings"
          :to="{ name: 'settings' }"
        >
          <o-icon icon="settings" />
        </router-link>
      </template>
    </o-map>
    <div
      class="c-overlay"
      :class="{
        'c-overlay--autofill': destinationActive
      }"
    >
      <div
        class="c-overlay-row c-overlay-row--stretch"
        v-if="destinationActive"
      >
        <div class="c-autocomplete-results">
          <o-list-item
            label="Antwerpen-Centraal"
            :chevron="false"
            link="route/search"
          />
          <o-list-item label="Gent-Sint-Pieters" :chevron="false" />
          <o-list-item label="Eiermarkt, Antwerpen" :chevron="false" />
          <o-list-item label="Ajuinlei 1, Gent" :chevron="false" />
          <o-list-item label="Grote Markt, Brussel" :chevron="false" />
        </div>
      </div>
      <div class="c-overlay-row">
        <div class="c-shortcuts" v-if="!destinationActive">
          <router-link
            to="wallet"
            class="c-shortcut"
            v-if="$store.state.showWalletButton"
          >
            <o-icon icon="tickets" />
            <div class="c-shortcut__label">Mijn tickets</div>
          </router-link>
          <router-link
            to="tickets"
            class="c-shortcut"
            v-if="$store.state.showTicketsButton"
          >
            <o-icon icon="plus" />
            <div class="c-shortcut__label">Producten</div>
          </router-link>
        </div>
      </div>
    </div>
  </o-view>
</template>

<script>
import OActiveRoute from '@/components/OActiveRoute.vue'
import OMap from '@/components/OMap.vue'

export default {
  name: 'Home',
  components: {
    OActiveRoute,
    OMap
  },
  data() {
    return {
      destinationActive: false,
      activeRoute: true,
      markers: [
        {
          coordinates: [3.715, 51.05],
          type: 'bluebike',
          title: 'Blue-bike A',
          link: 'sales/bike/bluebike',
          status: 'unavailable'
        },
        {
          coordinates: [3.726, 51.0578],
          type: 'bluebike',
          title: 'Blue-bike B',
          link: 'sales/bike/bluebike',
          status: 'available'
        },
        {
          coordinates: [3.714, 51.053],
          type: 'delijn',
          title: 'Bushalte A',
          link: 'sales/ov/delijn'
        },
        {
          coordinates: [3.715, 51.0562],
          type: 'delijn',
          title: 'Tramhalte A',
          link: 'sales/ov/delijn'
        },
        {
          coordinates: [3.739, 51.0549],
          type: 'bluebike',
          title: 'Blue-bike Gent-Dampoort',
          link: 'sales/bike/bluebike',
          status: 'available'
        }
      ]
    }
  },
  methods: {
    toggleDestination() {
      this.destinationActive = !this.destinationActive
    }
  }
}
</script>

<style lang="scss">
.c-home-top {
  left: 0rem;
  position: absolute;
  right: 0rem;
  top: 0rem;
  z-index: 1;
}

.c-home .c-map-button--center,
.c-home .c-map-button--settings,
.c-home .c-map-button--favorites {
  bottom: 8rem;
  position: absolute;
}

.c-home .c-map-button--settings {
  right: 1.6rem;
}

.c-home .c-map-button--favorites {
  right: 6.4rem;
}

.c-overlay {
  background: rgba($primary-color, 0.97);
  background: var(--primary-color-overlay);
  border-radius: $border-radius-large $border-radius-large 0 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  left: 0;
  min-height: 0;
  padding: 0.8rem 0.8rem 0 0.8rem;
  position: absolute;
  right: 0;
  transition: all 0.2s ease-in-out;
  z-index: 10;
}

.c-overlay--autofill {
  min-height: 24rem;
  max-height: 24rem;
}

.c-overlay-row {
  flex: none;
  & + & {
    margin-top: 0.8rem;
  }
}

.c-overlay-row--flex {
  display: flex;
}

.c-overlay-row--stretch {
  flex: 1 1 0;
  overflow: auto;
}

.c-overlay-icon {
  color: rgba(#fff, 0.7);
  cursor: pointer;
  padding: 1.2rem;

  .c-icon {
    display: block;
  }
}

.c-route {
  appearance: none;
  background: #fff;
  border: 0;
  border-radius: $border-radius;
  box-shadow: $box-shadow;
  color: $text-color;
  color: var(--text-color);
  cursor: text;
  display: block;
  flex: 1 1 auto;
  font: inherit;
  line-height: inherit;
  outline: 0;
  padding: 1.6rem;
  transition: opacity 0.2s ease-in-out;

  &::placeholder {
    color: $gray-500;
  }

  & + .c-overlay-icon {
    margin-left: 0.8rem;
  }
}

.c-autocomplete-results {
  color: #fff;
}

.c-shortcuts {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -0.4rem;
  transition: opacity 0.2s ease-in-out;
}

.c-shortcut {
  align-items: center;
  background-color: rgba(#fff, 0.1);
  border-radius: $border-radius;
  color: #fff;
  display: flex;
  flex: 1 0 calc(50% - 0.8rem);
  font-weight: 600;
  justify-content: center;
  margin: 0 0.4rem 0.8rem 0.4rem;
  padding: 1.2rem 0.8rem;
  text-align: center;

  .c-icon {
    margin-right: 0.8rem;
  }
}
</style>
